import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { useStyles } from './styles'

const CYCLE_KEYS = [
  'workspaceHome.streaming.cycle.thinking',
  'workspaceHome.streaming.cycle.reasoning',
  'workspaceHome.streaming.cycle.searching',
  'workspaceHome.streaming.cycle.analyzing',
  'workspaceHome.streaming.cycle.crunching',
  'workspaceHome.streaming.cycle.looking_up',
  'workspaceHome.streaming.cycle.connecting',
  'workspaceHome.streaming.cycle.almost_ready'
] as const

const MS_PER_WORD = 7000

const AnimatedDots = ({ className }: { className: string }) => (
  <span className={className} aria-hidden="true">
    <span>.</span>
    <span>.</span>
    <span>.</span>
  </span>
)

export const ThinkingShimmer = () => {
  const { styles } = useStyles()
  const { t } = useTranslation()
  const [step, setStep] = useState(0)

  useEffect(() => {
    const id = window.setInterval(() => {
      setStep((s) => s + 1)
    }, MS_PER_WORD)

    return () => window.clearInterval(id)
  }, [])

  const wordKey = CYCLE_KEYS[step % CYCLE_KEYS.length]

  return (
    <span
      key={step}
      className={styles.thinkingShimmer}
      aria-live="polite"
      aria-label={t('workspaceHome.streaming.thinking')}
    >
      {t(wordKey)}
      <AnimatedDots className={styles.thinkingDots} />
    </span>
  )
}
